import { render, staticRenderFns } from "./T2gSelect.vue?vue&type=template&id=7db9d56a&scoped=true"
import script from "./T2gSelect.vue?vue&type=script&lang=js"
export * from "./T2gSelect.vue?vue&type=script&lang=js"
import style0 from "./T2gSelect.vue?vue&type=style&index=0&id=7db9d56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db9d56a",
  null
  
)

export default component.exports